import { render, staticRenderFns } from "./EipYongU8Dialog.vue?vue&type=template&id=2567db50&"
import script from "./EipYongU8Dialog.vue?vue&type=script&lang=js&"
export * from "./EipYongU8Dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports